import AWS from "aws-sdk";

const accessKeyId = "SBH4FHR34CMTBGG5ZDR7";
const secretAccessKey = "1JaNsp4DZ3iAir3Iz87FQG2fec0SnitaPC+dUHsmE94";
const region = "nyc3";

const spacesEndpoint = new AWS.Endpoint(region + ".digitaloceanspaces.com");
const s3 = new AWS.S3({
  endpoint: spacesEndpoint,
  accessKeyId: accessKeyId,
  secretAccessKey: secretAccessKey
});

const bucketName = "geskitchen-space";

export { s3, bucketName };
